import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { DeviceType } from '@core/device-detection/device.type';
import { DeviceDetectionService } from '@core/device-detection/device-detection.service';
import { AppConfigService } from '@core/index';
import { LanguageService } from '@core/language/language.service';
import { TextContentService } from '@core/text-content/text-content.service';
import { AppStoreLogoData } from '@feature/types';
import { UIModule } from '@shared/ui';
import { Observable, share } from 'rxjs';

import { AppStoreDownload } from './types/mobile-app-store-download.type';

@Component({
  selector: 'jb-app-store',
  standalone: true,
  templateUrl: './mobile-app-store.component.html',
  styleUrls: ['./mobile-app-store.component.scss'],
  imports: [CommonModule, UIModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileAppStoreComponent implements OnInit {
  @Input() content: AppStoreLogoData[];

  isDesktop: boolean;
  mobileAppStoreUrl: string;
  mobileAppStoreBadge: string;
  badgeClass: string;
  deviceType: DeviceType;
  appleStoreUrl: string;
  googlePlayStoreUrl: string;
  currentLanguage: string;

  downloadContent$: Observable<AppStoreDownload> = this.textContentService
    .getJsonAsset('app-store-text')
    .pipe(share());

  constructor(
    private deviceService: DeviceDetectionService,
    private textContentService: TextContentService,
    private appConfigService: AppConfigService,
    private languageService: LanguageService,
  ) {}

  ngOnInit(): void {
    this.currentLanguage = this.languageService.getLanguage();

    this.deviceType = this.deviceService.detectDeviceType();
    this.isDesktop = this.deviceType === DeviceType.Other;

    // Set store URLs
    this.appleStoreUrl =
      this.appConfigService.mobileAppStoreBadges.apple.storeUrl;
    this.googlePlayStoreUrl =
      this.appConfigService.mobileAppStoreBadges.android.storeUrl;

    // Set badge URLs based on current language and device type
    if (!this.isDesktop) {
      this.mobileAppStoreUrl =
        this.deviceType === DeviceType.iOS
          ? this.appleStoreUrl
          : this.googlePlayStoreUrl;
      this.mobileAppStoreBadge =
        this.deviceType === DeviceType.iOS
          ? this.appConfigService.mobileAppStoreBadges.apple[
              this.currentLanguage
            ]
          : this.appConfigService.mobileAppStoreBadges.android[
              this.currentLanguage
            ];
      this.badgeClass =
        this.deviceType === DeviceType.iOS
          ? 'app-store-badge'
          : 'play-store-badge';
    }
  }
}
